import { AnnounceRequestError } from "@/features/announce/api/announceClient";

const ANNOUNCEMENT_MAX_RETRIES = 2;
const ANNOUNCEMENT_SCHEMA_MAX_RETRIES = 1;
const ANNOUNCEMENT_RETRY_BASE_DELAY_MS = 1_000;
const ANNOUNCEMENT_RETRY_MAX_DELAY_MS = 30_000;

const RETRYABLE_HTTP_STATUSES = new Set([408, 425, 429]);

export function shouldRetryAnnouncementRequest(
  failureCount: number,
  error: Error,
): boolean {
  if (!(error instanceof AnnounceRequestError)) return false;
  if (error.kind === "invalid_response") {
    return failureCount < ANNOUNCEMENT_SCHEMA_MAX_RETRIES;
  }
  if (error.kind === "network" || error.kind === "timeout") {
    return failureCount < ANNOUNCEMENT_MAX_RETRIES;
  }
  if (error.kind === "challenge") {
    return failureCount < ANNOUNCEMENT_MAX_RETRIES;
  }
  if (error.kind !== "http" || error.status === undefined) return false;
  return (
    failureCount < ANNOUNCEMENT_MAX_RETRIES &&
    (RETRYABLE_HTTP_STATUSES.has(error.status) || error.status >= 500)
  );
}

export function getAnnouncementRetryDelay(attemptIndex: number): number {
  return calculateAnnouncementRetryDelay(attemptIndex, Math.random);
}

export function calculateAnnouncementRetryDelay(
  attemptIndex: number,
  random: () => number,
): number {
  const exponentialDelay = Math.min(
    ANNOUNCEMENT_RETRY_BASE_DELAY_MS * 2 ** Math.max(0, attemptIndex),
    ANNOUNCEMENT_RETRY_MAX_DELAY_MS,
  );
  const jitter = 0.75 + Math.min(1, Math.max(0, random())) * 0.5;
  return Math.min(
    Math.round(exponentialDelay * jitter),
    ANNOUNCEMENT_RETRY_MAX_DELAY_MS,
  );
}
